<template>
  <v-menu transition="slide-y-transition" offset-y bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        class="tab-button"
        min-width="100%"
        v-bind="attrs"
        v-on="on"
        :disabled="isNotEnableButton()"
      >
        <p v-if="kind === 'category'">{{ makeJaLabelArray(inputTabText) }}</p>
        <p v-if="kind === 'point'">{{ convertSignedNumber(inputTabText) }}</p>
      </v-btn>
    </template>
    <v-list flat dense>
      <v-list-item v-for="(item, i) in items" :key="i" @click="clickItem(item)">
        <v-list-item-title>{{ makeJaLabelArray(item) }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import earthImpactDict from "../../assets/json/earth_impact_category";

export default {
  name: "CheckListItemCategoryTab",
  data: () => ({
    earthImpactDict: earthImpactDict
  }),
  computed: {
    inputTabText: {
      get() {
        return this.tabText;
      },
      set(value) {
        this.$emit("update:tabText", value);
      }
    }
  },
  methods: {
    clickItem(item) {
      this.inputTabText = item;
    },
    // 数値に符号をつけるための関数
    convertSignedNumber(num) {
      if (num > 0) {
        return "+" + String(num);
      } else if (num < 0) {
        return num;
      } else {
        return num;
      }
    },
    isNotEnableButton() {
      if (this.userAuthority === "MANAGER" && this.isUnderEditing) {
        return false;
      } else {
        return true;
      }
    },
    makeJaLabelArray(category) {
      for (let item of this.earthImpactDict) {
        if (item["category"] === category) {
          return item["ja_name"];
        }
      }
      return category;
    }
  },
  created() {},
  components: {},
  props: ["tabText", "items", "userAuthority", "kind", "isUnderEditing"]
};
</script>

<style scoped>
p {
  margin: 0;
  color: #707f89;
  font-size: 10px;
  font-weight: bold;
  border: 1px solid #707f89;
  border-radius: 13px;
  padding: 2px 4px;
}
.tab-button {
  width: 90%;
  padding: 0 !important;
}
</style>
